import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";

const ConfirmacionPendiente = () => {
  let { procesoMatricula, setProcesoMatricula,seteoDeObjectMatricula} = useMatricula();
  let { setPasoProcesoM,setPasoSegundaVistaProcesoM } = useProcesoMatricula();
  
  const {listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});


  const backBtnConfirmacionPendiente = () => {
     
    setPasoProcesoM(4);
    setPasoSegundaVistaProcesoM(true);
     
  };

  useEffect(() => {
     
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        confirmacion_msj_pago_pendiente: obtenerLabelEtiqueta(
          "lbl_confirmacion_msj_pago_pendiente",
          listadoEtiquetas
        ),
        confirmacion_msj_pendiente_proceso: obtenerLabelEtiqueta(
          "lbl_confirmacion_msj_pendiente_proceso",
          listadoEtiquetas
        ),
        confirmacion_volver_pago: obtenerLabelEtiqueta(
          "lbl_confirmacion_volver_pago",
          listadoEtiquetas
        ),

      });
    }
  }, [listadoEtiquetas]);
  const { confirmacion_msj_pago_pendiente,
    confirmacion_msj_pendiente_proceso,
    confirmacion_volver_pago} = etiquetas;

  return (
    <div className="col-sm-12 col-md-12 col-lg-12 steps-container ">
      <div className="card shadow-sm">
        <div className="card-body">
          <fieldset>
            <div className="form-body va-middle" style={{minHeight: '49vh'}}>
              <div className="text-center ">
                <div className="d-none d-md-block d-lg-block icon-pendiente warning  animate__animated animate__wobble animate-warning ">
                  <span className="body animate__animated animate__wobble animate-warning"></span>
                  <span className="dot "></span>
                </div>
                <div className="text-center mb-2 confirmation-title">
                  <h3 className="text-uppercase">{confirmacion_msj_pago_pendiente} </h3>

                  <p className="mb-0">
                  {confirmacion_msj_pendiente_proceso && confirmacion_msj_pendiente_proceso.split(".")[0]}.
                    <br /> 
                    {confirmacion_msj_pendiente_proceso && confirmacion_msj_pendiente_proceso.split(".")[1]}.
                  </p>
                </div>
                <div className="buttons-download d-flex justify-content-center my-5">
                  <button
                    type="button"
                    className="btn btn-outline-danger w-230 me-3 d-none d-md-block d-lg-block"
                  >
                    <Link onClick={backBtnConfirmacionPendiente} className="fw-medium">
                      {confirmacion_volver_pago}
                    </Link>{" "}
                  </button>
                </div>
              </div>
            </div>
            <Link
              onClick={backBtnConfirmacionPendiente}
              className="btn btn-primary w-100 fw-regular d-block  d-md-none d-lg-none"
            >
              {confirmacion_volver_pago}
            </Link>
          </fieldset>
        </div>
      </div>
    </div>
  );
};

export default ConfirmacionPendiente;
